import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/saira/wdth.css'
import '@fontsource-variable/saira/wdth-italic.css'
import { App } from './App'
import './index.css'
import { prepareMeasurementLocation } from './lib/measurement'

prepareMeasurementLocation()

const container = document.getElementById('root')
if (!container) throw new Error('Elemento #root não encontrado.')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
